import * as React from 'react';
import 'framework7-react';
import {Tour} from '../Tour';
import {Page, List, Card, CardHeader, CardContent, ContentBlockTitle} from 'framework7-react';


const divStyle = {
    display: "flex",
    justifyContent: "space-between",
    padding: "10px",
}

function isEmptyObject(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) return false;
        }
        return true;
    };

/// Display a list of Tours.
///
/// Clicking a tour list item will open the corresponding TourPopup containing
/// a list and map view of the tour.
export class ToursList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}

        this.selectTour = this.selectTour.bind(this);
        this.createTourCard = this.createTourCard.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (!this.state.buildingsMap || isEmptyObject(this.state.buildingsMap)) {
            this.constructBuildingsMap(this.props.buildings)
        }
    }

    constructBuildingsMap(buildings) {
        var buildingsMap = {};
        this.props.buildings.forEach((b) => {
            buildingsMap[b.slug] = b;
        });

        this.setState(prevState => ({buildingsMap: buildingsMap}));
    }

    selectTour (t) {
        this.props.setTour(t);
    }

    createTourCard(t) {
         return <div className="tour-card" key={t.slug}>
                <Card>
                    <div onClick={() => {this.selectTour(t);}}>
                        <CardHeader>
                            {t.name}
                            <i className="chevron_right f7-icons">chevron_right</i>
                        </CardHeader>
                        <CardContent>
                            {t.buildings.length > 0 &&
                                <div style={divStyle}>
                                    {t.buildings.length} {t.buildings.length === 1 ? " building" : " buildings"}
                                </div>
                            }                            
                        </CardContent>
                    </div>
                </Card>
            </div>
    }

    render() {
        if (this.props.tour != null) {
            return (
                <Page style={{background: "white"}} key="white">
                    <Tour
                        openMap={this.props.openMap}
                        tour={this.props.tour}
                        buildings={this.props.buildings}
                        onClose={() => {this.selectTour(null);}}/>
                </Page>
            );
        }
        let tours = this.props.tours.map(this.createTourCard);
        return (
            <Page className="tour-list-page">
                <ContentBlockTitle>Tours</ContentBlockTitle>
                <List>
                    {tours}
                </List>
            </Page>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/ToursList.jsx